// ─── PHOTO MOCKUP COMPOSITOR / 3-D PREVIEW ───────────────────────────────────
//
// Extracted from configurator.html's inline script (Phase 5 split). This IIFE
// is loaded via <script src> at the exact same document position it used to
// occupy inline, so all the "typeof preview3D !== 'undefined'" guards
// elsewhere in configurator.html (needed because this module is defined late
// in the page) keep working identically to before.
//
// Depends on globals defined earlier in configurator.html's own script:
// THREE (CDN), currentCat, CATEGORIES, currentJarColor, lidArtworkDataUrl,
// mylarBackArtworkDataUrl, mylarBottomArtworkDataUrl, currentUploadTab,
// showArtworkPreview(), setUploadTab().

var preview3D = (function() {

  // ── Product definitions ──────────────────────────────────────────────────
  // zone: { x, y, w, h } — 0-1 fractions of product image size.
  // threejs: true → render a spinning Three.js cylinder instead of 2-D composite.
  var PRODUCTS = {
    'labels': {
      photo: null,
      zone: { x: 0.22, y: 0.34, w: 0.56, h: 0.52 },
      products: {
        // body_wrap: label wraps body only; lid stays dark glass.
        'Flower Jar Labels': {
          threejs: true,
          jarType: 'body_wrap',
          R: 0.70, bodyH: 0.82, lidH: 0.30
        },
        'Miron Jar Labels': {
          threejs: true,
          jarType: 'full_wrap',
          R: 0.78, bodyH: 0.42, lidH: 0.42, camZ: 2.4
        },
        // 2-D composite: artwork composited onto the circular label face on the roll photo
        'Roll Labels': {
          photo: (window.VP_CDN+"customlabels_rolllabels.png?v=b42671f2fd"),
          zone: { x: 0.170, y: 0.456, w: 0.361, h: 0.361, shape: 'circle' }
        }
      }
    },
    'packaging': {
      photo: (window.VP_CDN+"custompackaging_MylarBag.png?v=24ce28b3a0"),
      zone: { x: 0.22, y: 0.22, w: 0.56, h: 0.52 },
      products: {
        'Mylar Bags': { threejs: true, type: 'mylar' }
      }
    }
  };

  // ── Three.js live state ──────────────────────────────────────────────────
  var t3Scene, t3Cam, t3Renderer, t3Jar, t3AnimId;
  var t3RotY = 0, t3Auto = true, t3Drag = false, t3PrevX = 0;
  var t3Cleanup = null;
  var t3SetCameraView = null;   // set by activateThreeJS, used by public API
  var t3ApplyArtwork  = null;   // set by activateThreeJSMylar, refreshes texture only
  var mylarLoadGen    = 0;      // incremented on each activateThreeJSMylar call to cancel stale GLB callbacks
  var t3ViewTarget  = null;     // { pos:{x,y,z}, look:Vector3 }
  var t3ViewCurrent = null;

  var activeCanvas = null;

  // ── Mylar 2-D view state (persists across re-activations) ────────────────
  var mylarCurrentView = 'front';

  // ── Remove white background from artwork ─────────────────────────────────
  function removeWhiteBg(img, threshold) {
    threshold = threshold === undefined ? 230 : threshold;
    var oc = document.createElement('canvas');
    oc.width  = img.naturalWidth  || img.width  || 1;
    oc.height = img.naturalHeight || img.height || 1;
    var octx = oc.getContext('2d');
    octx.drawImage(img, 0, 0);
    var data = octx.getImageData(0, 0, oc.width, oc.height);
    var d = data.data, range = 255 - threshold;
    for (var i = 0; i < d.length; i += 4) {
      var minC = Math.min(d[i], d[i+1], d[i+2]);
      if (minC >= threshold)
        d[i+3] = Math.max(0, Math.round((255 - minC) * (255 / range)));
    }
    octx.putImageData(data, 0, 0);
    return oc;
  }

  // ── Three.js cylinder spinner ────────────────────────────────────────────
  //
  // jarType 'body_wrap'  (Flower Jar) — label wraps the body only; lid is dark glass.
  // jarType 'full_wrap'  (Miron Jar)  — label covers lid + body as one seamless band;
  //   the image is split proportionally: top slice → lid, bottom slice → body.
  //
  function activateThreeJS(artworkDataUrl, wrap, product) {
    var jarType = (product && product.jarType) || 'body_wrap';
    var W = wrap.clientWidth  || 320;
    var H = wrap.clientHeight || 280;

    // Scene
    t3Scene = new THREE.Scene();
    t3Scene.background = new THREE.Color(0xf5f5f5);

    // Camera — camZ is per-product so squat jars can be pulled in closer
    var camZ = (product && product.camZ) || 3.0;
    t3Cam = new THREE.PerspectiveCamera(38, W / H, 0.1, 50);
    t3Cam.position.set(0, 0.12, camZ);

    // Renderer — preserveDrawingBuffer so toDataURL() works for sim modal
    t3Renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    t3Renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    t3Renderer.setSize(W, H);
    wrap.appendChild(t3Renderer.domElement);
    activeCanvas = t3Renderer.domElement;

    // Lights
    t3Scene.add(new THREE.AmbientLight(0xffffff, 0.35));
    var key = new THREE.DirectionalLight(0xffffff, 0.90);
    key.position.set(-1.5, 2.5, 2.0);
    t3Scene.add(key);
    var rim = new THREE.DirectionalLight(0xc8d0ff, 0.28);
    rim.position.set(2.0, -1.0, -2.0);
    t3Scene.add(rim);

    // Jar dimensions — read from product schema so each product can have its
    // own proportions.  Defaults match a generic jar if nothing is specified.
    var R       = (product && product.R)     || 0.70;
    var BODY_H  = (product && product.bodyH) || 0.82;
    var LID_H   = (product && product.lidH)  || 0.30;
    var TOTAL_H = BODY_H + LID_H;
    var GAP     = 0.008;         // seam gap between lid and body
    var CW      = 2048;          // texture canvas width (for both canvases)
    var circumference = 2 * Math.PI * R;   // ≈ 4.40 world units

    // Canvas heights sized so each pixel represents the same real-world
    // distance horizontally and vertically — produces undistorted labels.
    //   canvas_h = CW × mesh_height / circumference
    var bodyCanvasH = Math.round(CW * BODY_H  / circumference) || 256;
    var lidCanvasH  = Math.round(CW * LID_H   / circumference) || 128;

    // Glass material — color driven by jar color picker
    var jarColor  = (product && product._jarColor) || 'black';
    var glassFill = jarColor === 'white' ? '#e0e0e2'
                  : jarColor === 'clear' ? '#b8d0e8'
                  : '#0c0c10';
    var glassProps = jarColor === 'white'
      ? { color: 0xe0e0e2, specular: 0xffffff, shininess: 80 }
      : jarColor === 'clear'
        ? { color: 0xb8d0e8, transparent: true, opacity: 0.30, specular: 0xffffff, shininess: 200 }
        : { color: 0x0c0c10, specular: 0x404055, shininess: 150 };
    var glassMat = new THREE.MeshPhongMaterial(glassProps);

    t3Jar = new THREE.Group();

    // ─ Body mesh ─────────────────────────────────────────────────────────────
    var bodyCanvas = document.createElement('canvas');
    bodyCanvas.width = CW; bodyCanvas.height = bodyCanvasH;
    var bctx = bodyCanvas.getContext('2d');
    bctx.fillStyle = glassFill;
    bctx.fillRect(0, 0, CW, bodyCanvasH);
    var bodyTex = new THREE.CanvasTexture(bodyCanvas);
    var bodySpecular  = jarColor === 'white' ? 0xffffff : 0x303038;
    var bodyShininess = jarColor === 'clear'  ? 120 : 80;
    var bodyMat = new THREE.MeshPhongMaterial({ map: bodyTex, specular: bodySpecular, shininess: bodyShininess });
    // full_wrap: open both ends so the label fills wall-to-wall with no dark
    // cap faces at top/bottom.  body_wrap: body open (label fills it), lid
    // closed so the solid dark lid-top cap is visible (correct for a flower jar).
    var bodyOpen = true;
    var lidOpen  = (jarType === 'full_wrap');

    var bodyMesh = new THREE.Mesh(new THREE.CylinderGeometry(R, R, BODY_H, 64, 1, bodyOpen), bodyMat);
    bodyMesh.position.y = -(LID_H + GAP) / 2;
    t3Jar.add(bodyMesh);

    // ─ Lid mesh ──────────────────────────────────────────────────────────────
    var lidCanvas = null, lctx = null, lidTex = null;
    var lidMat;
    if (jarType === 'full_wrap') {
      // Lid gets its own textured canvas — same label, upper slice
      lidCanvas = document.createElement('canvas');
      lidCanvas.width = CW; lidCanvas.height = lidCanvasH;
      lctx = lidCanvas.getContext('2d');
      lctx.fillStyle = glassFill;
      lctx.fillRect(0, 0, CW, lidCanvasH);
      lidTex = new THREE.CanvasTexture(lidCanvas);
      lidMat = new THREE.MeshPhongMaterial({ map: lidTex, specular: 0x404055, shininess: 120 });
    } else {
      lidMat = glassMat.clone();   // body_wrap: lid stays dark glass
    }
    var lidMesh = new THREE.Mesh(new THREE.CylinderGeometry(R, R, LID_H, 64, 1, lidOpen), lidMat);
    lidMesh.position.y = (BODY_H + GAP) / 2;
    t3Jar.add(lidMesh);

    t3Scene.add(t3Jar);

    // ─ Bake artwork into texture(s) once the image loads ─────────────────────
    if (artworkDataUrl) {
      var artImg = new Image();
      artImg.onload = function() {
        if (jarType === 'full_wrap') {
          // Split the label image proportionally by jar height:
          //   top  LID_H/TOTAL_H  of the image  →  lid canvas
          //   bottom BODY_H/TOTAL_H of the image →  body canvas
          // Each canvas is already sized to match its surface's aspect ratio,
          // so drawImage fills it completely without distortion.
          var lidSrcH  = Math.round(artImg.height * LID_H  / TOTAL_H);
          var bodySrcH = artImg.height - lidSrcH;

          lctx.clearRect(0, 0, CW, lidCanvasH);
          lctx.fillStyle = glassFill;
          lctx.fillRect(0, 0, CW, lidCanvasH);
          lctx.drawImage(artImg,
            0, 0, artImg.width, lidSrcH,           // src: top slice (lid)
            0, 0, CW, lidCanvasH);                 // dst: fill lid canvas
          lidTex.needsUpdate = true;

          bctx.clearRect(0, 0, CW, bodyCanvasH);
          bctx.fillStyle = glassFill;
          bctx.fillRect(0, 0, CW, bodyCanvasH);
          bctx.drawImage(artImg,
            0, lidSrcH, artImg.width, bodySrcH,    // src: bottom slice (body)
            0, 0, CW, bodyCanvasH);                // dst: fill body canvas
          bodyTex.needsUpdate = true;

        } else {
          // body_wrap: full image wraps around the body only.
          // Stretch to fill the full canvas so the label is always fully visible
          // in the preview regardless of the uploaded artwork's aspect ratio.
          bctx.clearRect(0, 0, CW, bodyCanvasH);
          bctx.fillStyle = glassFill;
          bctx.fillRect(0, 0, CW, bodyCanvasH);
          bctx.drawImage(artImg, 0, 0, CW, bodyCanvasH);
          bodyTex.needsUpdate = true;
        }
      };
      artImg.src = artworkDataUrl;
    }

    // ─ Lid disc (top-face label) — all jar types ─────────────────────────────
    // body_wrap: separate lid artwork goes here (Flower Jar top label).
    // full_wrap: same — Miron Jar also gets a top-face disc for a separate lid label.
    var ldctx = null, lidDiscTex = null;
    var DS = 512;
    var lidDiscCanvas = document.createElement('canvas');
    lidDiscCanvas.width = DS; lidDiscCanvas.height = DS;
    ldctx = lidDiscCanvas.getContext('2d');
    ldctx.fillStyle = glassFill;
    ldctx.fillRect(0, 0, DS, DS);
    lidDiscTex = new THREE.CanvasTexture(lidDiscCanvas);
    var lidDiscMat = new THREE.MeshPhongMaterial({
      map: lidDiscTex, specular: bodySpecular, shininess: 60
    });
    var lidDiscMesh = new THREE.Mesh(new THREE.CircleGeometry(R - 0.005, 64), lidDiscMat);
    lidDiscMesh.rotation.x = -Math.PI / 2;
    // Position at the very top of the lid
    lidDiscMesh.position.y = (BODY_H + GAP) / 2 + LID_H / 2 + 0.001;
    t3Jar.add(lidDiscMesh);

    // ─ Bake lid artwork onto disc ─────────────────────────────────────────────
    if (lidArtworkDataUrl && ldctx) {
      var ldImg = new Image();
      ldImg.onload = function() {
        var DS = 512;
        ldctx.clearRect(0, 0, DS, DS);
        ldctx.fillStyle = glassFill;
        ldctx.fillRect(0, 0, DS, DS);
        var scale = Math.min(DS / ldImg.width, DS / ldImg.height);
        var dw = ldImg.width * scale, dh = ldImg.height * scale;
        ldctx.drawImage(ldImg, (DS - dw) / 2, (DS - dh) / 2, dw, dh);
        lidDiscTex.needsUpdate = true;
      };
      ldImg.src = lidArtworkDataUrl;
    }

    // ─ Camera view presets & lerp state ──────────────────────────────────────
    var jarTop = (BODY_H + GAP) / 2 + LID_H / 2;
    var sidePos  = { x: 0, y: 0.12,          z: camZ };
    var topPos   = { x: 0, y: camZ * 0.85,   z: camZ * 0.32 };
    var sideLook = new THREE.Vector3(0, 0,         0);
    var topLook  = new THREE.Vector3(0, jarTop * 0.6, 0);

    t3ViewTarget  = { pos: { x: sidePos.x, y: sidePos.y, z: sidePos.z }, look: sideLook.clone() };
    t3ViewCurrent = { pos: { x: sidePos.x, y: sidePos.y, z: sidePos.z }, look: sideLook.clone() };
    t3Cam.position.set(sidePos.x, sidePos.y, sidePos.z);
    t3Cam.lookAt(sideLook);

    // Set up the public setCameraView for this session
    t3SetCameraView = function(view) {
      var tPos  = view === 'top' ? topPos  : sidePos;
      var tLook = view === 'top' ? topLook : sideLook;
      t3ViewTarget.pos  = { x: tPos.x, y: tPos.y, z: tPos.z };
      t3ViewTarget.look = tLook.clone();
      if (view === 'side') t3Auto = true; // resume spin
      var btnS = document.getElementById('btnSideView');
      var btnT = document.getElementById('btnTopView');
      if (btnS) btnS.classList.toggle('active', view === 'side');
      if (btnT) btnT.classList.toggle('active', view === 'top');
    };

    // Populate jar view toggle buttons (regenerate in case mylar ran first)
    var viewToggle = document.getElementById('viewToggle');
    if (viewToggle) {
      viewToggle.innerHTML =
        '<button class="view-btn active" id="btnSideView" onclick="preview3D.setCameraView(\'side\')">&#8596; Side</button>' +
        '<button class="view-btn" id="btnTopView" onclick="preview3D.setCameraView(\'top\')">&#8645; Top</button>';
      viewToggle.classList.add('visible');
    }

    // ─ Drag-to-rotate ─
    var el = t3Renderer.domElement;
    t3RotY = 0; t3Auto = true; t3Drag = false;

    function onMD(e) { t3Drag = true;  t3PrevX = e.clientX; t3Auto = false; }
    function onMU()  { t3Drag = false; }
    function onMM(e) { if (t3Drag) { t3RotY += (e.clientX - t3PrevX) * 0.012; t3PrevX = e.clientX; } }
    function onTS(e) { t3Drag = true;  t3PrevX = e.touches[0].clientX; t3Auto = false; }
    function onTE()  { t3Drag = false; }
    function onTM(e) { if (t3Drag) { t3RotY += (e.touches[0].clientX - t3PrevX) * 0.012; t3PrevX = e.touches[0].clientX; } }

    el.addEventListener('mousedown',  onMD);
    window.addEventListener('mouseup',   onMU);
    window.addEventListener('mousemove', onMM);
    el.addEventListener('touchstart', onTS, { passive: true });
    window.addEventListener('touchend',  onTE);
    window.addEventListener('touchmove', onTM, { passive: true });

    t3Cleanup = function() {
      el.removeEventListener('mousedown',  onMD);
      window.removeEventListener('mouseup',   onMU);
      window.removeEventListener('mousemove', onMM);
      el.removeEventListener('touchstart', onTS);
      window.removeEventListener('touchend',  onTE);
      window.removeEventListener('touchmove', onTM);
      if (t3AnimId) { cancelAnimationFrame(t3AnimId); t3AnimId = null; }
      if (t3Renderer) { t3Renderer.dispose(); t3Renderer = null; }
      t3Scene = t3Cam = t3Jar = null;
    };

    // Show drag hint
    var hint = document.getElementById('preview3dHint');
    if (hint) hint.style.display = 'block';

    // Render loop — includes smooth camera lerp toward view target
    (function animate() {
      t3AnimId = requestAnimationFrame(animate);
      if (t3Auto) t3RotY += 0.008;
      t3Jar.rotation.y = t3RotY;
      // Lerp camera position and lookAt toward current view target
      if (t3ViewTarget && t3ViewCurrent) {
        var lp = 0.07;
        t3ViewCurrent.pos.x += (t3ViewTarget.pos.x - t3ViewCurrent.pos.x) * lp;
        t3ViewCurrent.pos.y += (t3ViewTarget.pos.y - t3ViewCurrent.pos.y) * lp;
        t3ViewCurrent.pos.z += (t3ViewTarget.pos.z - t3ViewCurrent.pos.z) * lp;
        t3ViewCurrent.look.lerp(t3ViewTarget.look, lp);
        t3Cam.position.set(t3ViewCurrent.pos.x, t3ViewCurrent.pos.y, t3ViewCurrent.pos.z);
        t3Cam.lookAt(t3ViewCurrent.look);
      }
      t3Renderer.render(t3Scene, t3Cam);
    })();
  }

  // ── 2-D photo compositor ─────────────────────────────────────────────────
  function composite(productImg, artworkCanvas, zone, canvas) {
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    var pNW = productImg.naturalWidth  || 1;
    var pNH = productImg.naturalHeight || 1;
    var pScale = Math.min(W / pNW, H / pNH) * 0.92;
    var pW = pNW * pScale, pH = pNH * pScale;
    var pX = (W - pW) / 2,    pY = (H - pH) / 2;
    var lx = pX + zone.x * pW, ly = pY + zone.y * pH;
    var lw = zone.w * pW,       lh = zone.h * pH;
    ctx.fillStyle = '#f5f5f5';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(productImg, pX, pY, pW, pH);
    var aw = artworkCanvas.width || artworkCanvas.naturalWidth  || 1;
    var ah = artworkCanvas.height || artworkCanvas.naturalHeight || 1;

    if (zone.shape === 'circle') {
      // Cover-scale and clip to circle
      var cR  = Math.min(lw, lh) / 2;
      var cCx = lx + lw / 2, cCy = ly + lh / 2;
      var sc  = Math.max(lw / aw, lh / ah); // cover
      var aW2 = aw * sc, aH2 = ah * sc;
      ctx.save();
      ctx.beginPath(); ctx.arc(cCx, cCy, cR, 0, Math.PI * 2); ctx.clip();
      ctx.drawImage(artworkCanvas, cCx - aW2 / 2, cCy - aH2 / 2, aW2, aH2);
      ctx.restore();
      // Subtle product-photo screen overlay to blend lighting
      ctx.save();
      ctx.beginPath(); ctx.arc(cCx, cCy, cR, 0, Math.PI * 2); ctx.clip();
      ctx.globalCompositeOperation = 'screen';
      ctx.globalAlpha = 0.12;
      ctx.drawImage(productImg, pX, pY, pW, pH);
      ctx.globalAlpha = 1.0;
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();
    } else {
      var aScale = Math.min(lw / aw, lh / ah);
      var aW = aw * aScale, aH = ah * aScale;
      var aX = lx + (lw - aW) / 2, aY = ly + (lh - aH) / 2;
      ctx.save();
      ctx.beginPath(); ctx.rect(lx, ly, lw, lh); ctx.clip();
      ctx.drawImage(artworkCanvas, aX, aY, aW, aH);
      ctx.restore();
      ctx.save();
      ctx.beginPath(); ctx.rect(lx, ly, lw, lh); ctx.clip();
      ctx.globalCompositeOperation = 'screen';
      ctx.globalAlpha = 0.15;
      ctx.drawImage(productImg, pX, pY, pW, pH);
      ctx.globalAlpha = 1.0;
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();
    }
  }

  // ── Public: activate preview ─────────────────────────────────────────────
  function activate(artworkDataUrl) {
    if (window.vpStickerPreview && window.vpStickerPreview.supports()) {
      window.vpStickerPreview.sync();
      return;
    }
    // If the mylar GLB is already loaded, just refresh the texture — skip full reinit
    if (t3ApplyArtwork && currentCat === 'packaging') {
      var url = mylarCurrentView === 'back'   ? mylarBackArtworkDataUrl :
                mylarCurrentView === 'bottom' ? mylarBottomArtworkDataUrl : artworkDataUrl;
      if (url) t3ApplyArtwork(url, mylarCurrentView || 'front');
      return;
    }
    deactivate();

    var product = PRODUCTS[currentCat];
    if (!product) { showArtworkPreview(); return; }

    // Per-product Three.js check
    var cat = CATEGORIES[currentCat];
    var productName = cat && (cat._customName || cat.name);
    var perProduct  = product.products && product.products[productName];

    if (perProduct && perProduct.threejs) {
      // 10/12: three r128 loads on first use (vp-lazy.js); come back here once it is in.
      if (typeof THREE === 'undefined' || !THREE.GLTFLoader) {
        if (window.vpLazy) window.vpLazy('three128').then(function () { activate(artworkDataUrl); }, function () {});
        return;
      }
      var wrap = document.getElementById('preview3dWrap');
      if (!wrap) return;
      wrap.innerHTML = '';

      if (perProduct.type === 'mylar') {
        // Mylar: the canvas wrap becomes visible as soon as the WebGL renderer is
        // initialised (inside activateThreeJSMylar), so the 3D scene appears
        // immediately. The static product image is faded out once the GLB finishes
        // loading. Read canvas dimensions from the always-visible .product-preview
        // parent synchronously — #preview3dWrap may still return 0 from getBCR.
        var _wrap = wrap;
        var _par = wrap.parentElement;
        var _pRect = _par ? _par.getBoundingClientRect() : null;
        var _pW = (_pRect && Math.round(_pRect.width))  || (_par && _par.clientWidth)  || 0;
        var _pH = (_pRect && Math.round(_pRect.height)) || (_par && _par.clientHeight) || 0;
        var queuedGen = mylarLoadGen;
        setTimeout(function() {
          if (queuedGen !== mylarLoadGen || currentCat !== 'packaging') return;
          activateThreeJSMylar(_wrap, _pW || 400, _pH || 400);
        }, 0);
      } else {
        // Jar path: show canvas and hide product image immediately.
        wrap.style.display = 'block';
        var productImgEl = document.getElementById('productImg');
        if (productImgEl) productImgEl.style.visibility = 'hidden';
        if (typeof currentJarColor !== 'undefined') perProduct._jarColor = currentJarColor;
        activateThreeJS(artworkDataUrl, wrap, perProduct);
      }
      return;
    }

    // 2-D composite path — use per-product photo/zone if defined, else top-level
    var photoSrc = (perProduct && perProduct.photo) ? perProduct.photo : product.photo;
    var zoneDef  = (perProduct && perProduct.zone)  ? perProduct.zone  : product.zone;
    if (!photoSrc) { showArtworkPreview(); return; }

    var wrap = document.getElementById('preview3dWrap');
    if (!wrap) { showArtworkPreview(); return; }
    var W = wrap.offsetWidth  || 320;
    var H = wrap.offsetHeight || 280;
    if (!W || !H) { showArtworkPreview(); return; }

    var canvas = document.createElement('canvas');
    canvas.width = W; canvas.height = H;
    activeCanvas = canvas;

    var productImgEl = document.getElementById('productImg');
    var photoImg = new Image();
    photoImg.crossOrigin = 'anonymous';
    photoImg.onload = function() {
      var artImg = new Image();
      artImg.onload = function() {
        composite(photoImg, artImg, zoneDef, canvas);
        wrap.innerHTML = '';
        wrap.appendChild(canvas);
        wrap.style.display = 'block';
        if (productImgEl) productImgEl.style.visibility = 'hidden';
      };
      artImg.src = artworkDataUrl;
    };
    photoImg.src = photoSrc;
  }

  // ── 2-D mylar bag photo composite ────────────────────────────────────────
  //
  // Displays the actual product photos scaled to fit a canvas, then
  // composites user artwork into the printable zone on each panel.
  //
  // View toggle: Front  → assets/mylar_front.png  (upright)
  //              Back   → assets/mylar_front.png  (horizontally mirrored)
  //              Bottom → assets/mylar_bottom.jpg
  //

  function activateThreeJSMylar(wrap, fallbackW, fallbackH) {
    // Capture current generation so stale async GLB callbacks can self-cancel.
    var thisGen = ++mylarLoadGen;

    // Prefer the fallback dimensions pre-read from .product-preview (always in layout).
    // Only fall back to getBoundingClientRect / hard-coded 400 if no fallback supplied.
    var rect = wrap.getBoundingClientRect();
    var W = Math.round(rect.width)  || fallbackW || 400;
    var H = Math.round(rect.height) || fallbackH || 400;

    // ── Scene ──────────────────────────────────────────────────────────────
    t3Scene = new THREE.Scene();
    t3Scene.background = new THREE.Color(0xe4e4e4);

    t3Cam = new THREE.PerspectiveCamera(38, W / H, 0.1, 50);
    t3Cam.position.set(0, 0.1, 4.5);
    t3Cam.lookAt(0, 0, 0);

    t3Renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    t3Renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    t3Renderer.setSize(W, H);
    t3Renderer.physicallyCorrectLights = true;
    wrap.appendChild(t3Renderer.domElement);
    activeCanvas = t3Renderer.domElement;

    // Show the canvas immediately so the test (and user) can see the renderer is live.
    // The static product image stays visible underneath until the GLB finishes loading,
    // at which point the onload callback hides it. If the wrap stays hidden until GLB
    // onload, any thrown error or slow network causes a permanent invisible canvas.
    wrap.style.display = 'block';

    // ── Lighting ───────────────────────────────────────────────────────────
    // Moderate ambient — enough to light dark sides without washing out specular
    t3Scene.add(new THREE.AmbientLight(0xffffff, 0.45));
    // Strong key light from upper-front-right — creates the main shiny hotspot
    var keyL = new THREE.DirectionalLight(0xffffff, 1.8);
    keyL.position.set(2, 3, 4); t3Scene.add(keyL);
    // Cool fill from left/back for depth contrast
    var fillL = new THREE.DirectionalLight(0xb0c8ff, 0.55);
    fillL.position.set(-3, 1, -1); t3Scene.add(fillL);
    // Warm rim from bottom/back
    var rimL = new THREE.DirectionalLight(0xefefef, 0.35);
    rimL.position.set(0, -2, -3); t3Scene.add(rimL);
    // Point lights for tight specular reflections — essential on shiny metallic surfaces
    var ptTop = new THREE.PointLight(0xffffff, 2.0, 12);
    ptTop.position.set(0.5, 3.5, 2.5); t3Scene.add(ptTop);
    var ptSide = new THREE.PointLight(0xddeeff, 1.4, 10);
    ptSide.position.set(-2.5, 0.5, 1.5); t3Scene.add(ptSide);

    // ── Environment map — essential for metallic materials ─────────────────
    // MeshPhysicalMaterial with metalness relies on env reflections to look shiny.
    // Without one, metals appear black. We bake a simple studio gradient into
    // a PMREM env map so the silver bag reflects a bright sky/ground.
    (function() {
      try {
        var envCv = document.createElement('canvas');
        envCv.width = 512; envCv.height = 256;
        var ec = envCv.getContext('2d');
        // Studio gradient: bright white top, soft blue mid, dark bottom
        var g = ec.createLinearGradient(0, 0, 0, 256);
        g.addColorStop(0.00, '#e8eeff'); // cool sky
        g.addColorStop(0.30, '#ffffff'); // hot bright zone
        g.addColorStop(0.55, '#f0f4ff'); // soft highlight
        g.addColorStop(0.80, '#b0bcc8'); // mid grey — lifted to prevent dark gusset
        g.addColorStop(1.00, '#7a8898'); // light floor — gusset reflects this, keep it bright
        ec.fillStyle = g;
        ec.fillRect(0, 0, 512, 256);
        // Add a couple of bright studio light "reflections" on the left side
        var spot = ec.createRadialGradient(80, 80, 0, 80, 80, 120);
        spot.addColorStop(0, 'rgba(255,255,255,0.9)');
        spot.addColorStop(1, 'rgba(255,255,255,0)');
        ec.fillStyle = spot; ec.fillRect(0, 0, 512, 256);
        var spot2 = ec.createRadialGradient(420, 60, 0, 420, 60, 80);
        spot2.addColorStop(0, 'rgba(220,235,255,0.7)');
        spot2.addColorStop(1, 'rgba(220,235,255,0)');
        ec.fillStyle = spot2; ec.fillRect(0, 0, 512, 256);

        var envTex = new THREE.CanvasTexture(envCv);
        envTex.mapping = THREE.EquirectangularReflectionMapping;
        var pmrem = new THREE.PMREMGenerator(t3Renderer);
        pmrem.compileEquirectangularShader();
        var envMap = pmrem.fromEquirectangular(envTex).texture;
        t3Scene.environment = envMap;
        envTex.dispose();
        pmrem.dispose();
      } catch(e) { console.warn('Env map generation failed:', e); }
    })();

    // ── Bag group (rotated by drag) ────────────────────────────────────────
    var bagGroup = new THREE.Group();
    t3Scene.add(bagGroup);
    t3Jar = bagGroup;

    // ── UV-mapped mesh sets (artwork applied directly to GLB mesh materials) ──
    var uvFrontMeshes  = [];   // GLB mesh(es) whose centroid is on the front (+Z) face
    var uvBackMeshes   = [];   // GLB mesh(es) whose centroid is on the back  (-Z) face
    var uvBottomMeshes = [];   // GLB mesh(es) whose centroid is on the bottom gusset
    var uvModeActive   = false; // true once we have at least one classified mesh

    // Legacy overlay planes (used only when UV mesh classification fails / for the fallback box)
    var planeFront  = null;
    var planeBack   = null;
    var planeBottom = null;
    var planePrintW = 1;
    var planePrintH = 1;
    var planePrintW_bot = 1;
    var planePrintH_bot = 1;
    var groupRotY  = 0;
    var targetRotY = 0;    // lerp target for Y rotation; set to 0 when a view button is clicked
    var groupRotX  = 0;    // tilt: lerps toward targetRotX
    var targetRotX = 0;    // 0 = upright, Math.PI/2 = tipped to show bottom
    var autoRotate = false;  // stays off until the GLB finishes loading
    var isDragging = false;
    var prevX      = 0;

    // ── Camera view presets ────────────────────────────────────────────────
    // This GLB's visual front faces +Z (max-Z side), so front camera is at +Z.
    // 'up' must be perpendicular to the view direction — bottom view looks straight
    // up the Y axis so up=[0,1,0] (the default) causes gimbal lock; use [0,0,-1] instead
    // so the bag's front face appears at the top of the bottom view.
    var CAM_VIEWS = {
      front:  { pos: [0,  0.1,  4.5], look: [0,    0, 0], up: [0, 1, 0] },
      back:   { pos: [0,  0.1, -4.5], look: [0,    0, 0], up: [0, 1, 0] },
      // Below-front angle: shows gusset oval face-on without the edge-on thin-strip problem.
      // Looking toward the lower bag, up=[0,1,0] works fine here (no gimbal lock).
      bottom: { pos: [0, -3.2,  2.8], look: [0, -1.1, 0], up: [0, 1, 0] }
    };
    var camPos  = new THREE.Vector3(0, 0.1, 4.5);
    var camLook = new THREE.Vector3(0, 0, 0);

    function setCamTarget(view) {
      var v = CAM_VIEWS[view] || CAM_VIEWS.front;
      camPos.set(v.pos[0], v.pos[1], v.pos[2]);
      camLook.set(v.look[0], v.look[1], v.look[2]);
      // Update camera up immediately so lookAt never sees a degenerate (parallel) up vector
      t3Cam.up.set(v.up[0], v.up[1], v.up[2]);
      // No bag tilt — camera position alone determines the view angle.
      // Tilting the bag rotates the planes with it, which breaks plane positioning.
      targetRotX = 0;
    }

    // ── Artwork plane helpers ──────────────────────────────────────────────
    // wBot = width at bottom edge, wTop = width at top edge.
    // If they differ a trapezoid is created so the artwork hugs the tapered bag profile.
    function makePlane(wBot, wTop, h, px, py, pz, rx, ry) {
      var geo;
      if (Math.abs(wBot - wTop) < 0.001) {
        geo = new THREE.PlaneGeometry(wBot, h);
      } else {
        var hbw = wBot / 2, htw = wTop / 2, hh = h / 2;
        geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array([
          -hbw, -hh, 0,   hbw, -hh, 0,   htw, hh, 0,  -htw, hh, 0
        ]), 3));
        geo.setAttribute('uv', new THREE.BufferAttribute(new Float32Array([
          0, 0,   1, 0,   1, 1,   0, 1
        ]), 2));
        geo.setIndex([0, 1, 2,  0, 2, 3]);
        geo.computeVertexNormals();
      }
      var mat = new THREE.MeshBasicMaterial({
        transparent: true, opacity: 1.0, depthWrite: false, side: THREE.DoubleSide,
        visible: false,          // invisible until artwork is applied — prevents white/black ghost
        polygonOffset: true,     // push plane flush on the bag without a physical Z gap
        polygonOffsetFactor: -2,
        polygonOffsetUnits:  -4
      });
      var mesh = new THREE.Mesh(geo, mat);
      mesh.position.set(px, py, pz);
      mesh.rotation.set(rx || 0, ry || 0, 0);
      bagGroup.add(mesh);
      return mesh;
    }

    // Builds a surface-conforming ribbon that follows the bag's Z contour at each height band.
    // zArr[r] = Z position for row r; hwArr[r] = half-width for row r.
    // Each row is a pair of vertices (left / right) at that height and depth.
    function makeConformingPlane(zArr, hwArr, yLo, yStep, nBands, ry) {
      var pos = [], uvArr = [], idxArr = [];
      for (var r = 0; r <= nBands; r++) {
        var y = yLo + r * yStep, vt = r / nBands, z = zArr[r], hw = hwArr[r];
        pos.push(-hw, y, z,   hw, y, z);
        uvArr.push(0, vt,   1, vt);
        if (r > 0) {
          var b = (r - 1) * 2;
          idxArr.push(b, b+2, b+1,   b+1, b+2, b+3);
        }
      }
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(pos),   3));
      geo.setAttribute('uv',       new THREE.BufferAttribute(new Float32Array(uvArr), 2));
      geo.setIndex(idxArr);
      geo.computeVertexNormals();
      var mat = new THREE.MeshBasicMaterial({
        transparent: true, opacity: 1.0, depthWrite: false, side: THREE.DoubleSide,
        visible: false,
        polygonOffset: true, polygonOffsetFactor: -2, polygonOffsetUnits: -4
      });
      var mesh = new THREE.Mesh(geo, mat);
      if (ry) mesh.rotation.y = ry;
      bagGroup.add(mesh);
      return mesh;
    }

    // Apply artwork image to a specific bag face.
    //
    // Shader mode (primary): updates the appropriate artwork texture uniform on the
    // injected PBR shader so the artwork appears directly on the GLB mesh surface.
    // The shader selects front/back/bottom by reading local-space normals in GLSL.
    //
    // Overlay-plane mode (fallback): used when the GLB fails to load or the shader
    // injection path is not active.
    function applyArtwork(dataUrl, view) {
      view = view || mylarCurrentView || 'front';
      if (!dataUrl) return;

      var img = new Image();
      img.onload = function() {

        // ── Shader / UV mode path ────────────────────────────────────────────
        if (uvModeActive && bagGroup.userData.artShaderUniforms) {
          var su  = bagGroup.userData.artShaderUniforms;
          var key = view === 'back' ? 'u_backTex' : view === 'bottom' ? 'u_bottomTex' : 'u_frontTex';

          // Draw artwork into a 2048×2048 canvas (fill mode).
          // AR correction is applied in the shader using the image's native AR uniform
          // so circles appear undistorted regardless of the face aspect ratio.
          var tc = document.createElement('canvas');
          tc.width = tc.height = 2048;
          var tx = tc.getContext('2d');
          tx.drawImage(img, 0, 0, 2048, 2048);

          if (su[key].value) su[key].value.dispose();
          var tex = new THREE.CanvasTexture(tc);
          tex.anisotropy = t3Renderer.capabilities.getMaxAnisotropy(); // sharpen at oblique angles
          tex.flipY = false;
          tex.needsUpdate = true;
          su[key].value = tex;
          // Pass image AR to shader so it can apply AR-correct UV mapping
          var _arKey = key === 'u_backTex' ? 'u_backAR' : key === 'u_bottomTex' ? 'u_bottomAR' : 'u_frontAR';
          if (su[_arKey]) su[_arKey].value = img.naturalWidth / img.naturalHeight;
          return;
        }

        // ── Overlay-plane fallback ───────────────────────────────────────────
        var plane = view === 'back' ? planeBack : view === 'bottom' ? planeBottom : planeFront;
        if (!plane) return;
        var fW = (view === 'bottom') ? planePrintW_bot : planePrintW;
        var fH = (view === 'bottom') ? planePrintH_bot : planePrintH;
        var faceAR = (fW > 0 && fH > 0) ? fW / fH : 1;
        var pW, pH;
        if (faceAR >= 1) { pW = 1024; pH = Math.round(1024 / faceAR); }
        else             { pH = 1024; pW = Math.round(1024 * faceAR); }
        pW = Math.max(pW, 1);  pH = Math.max(pH, 1);
        var pc = document.createElement('canvas');
        pc.width = pW;  pc.height = pH;
        var pt = pc.getContext('2d');
        var artAR = img.width / img.height;
        var canAR = pW / pH;
        if (view === 'bottom') {
          var isPortrait = img.height > img.width;
          var effW = isPortrait ? img.height : img.width;
          var effH = isPortrait ? img.width  : img.height;
          pt.save();
          pt.translate(pW / 2, pH / 2);
          if (isPortrait) pt.rotate(Math.PI / 2);
          var gsc = Math.max(pW / effW, pH / effH);
          pt.drawImage(img, -effW * gsc / 2, -effH * gsc / 2, effW * gsc, effH * gsc);
          pt.restore();
        } else {
          var sc2 = (artAR > canAR) ? pH / img.height : pW / img.width;
          var dw2 = img.width * sc2, dh2 = img.height * sc2;
          pt.drawImage(img, (pW - dw2) / 2, (pH - dh2) / 2, dw2, dh2);
        }
        if (plane.material.map) plane.material.map.dispose();
        var ptex = new THREE.CanvasTexture(pc);
        ptex.needsUpdate = true;
        plane.material.map     = ptex;
        plane.material.visible = true;
        plane.material.needsUpdate = true;
      };
      img.src = dataUrl;
    }

    // ── Load GLB ───────────────────────────────────────────────────────────
    // ── Start render loop immediately so canvas shows the gray background ──
    // The GLB callbacks just add geometry to the already-running scene.
    // Without this, the canvas stays blank until the network fetch finishes.
    function startLoop() {
      function loop() {
        t3AnimId = requestAnimationFrame(loop);
        if (autoRotate) {
          groupRotY += 0.004;
          targetRotY = groupRotY; // keep target in sync while auto-rotating
        } else {
          groupRotY += (targetRotY - groupRotY) * 0.10; // smooth snap to target
        }
        bagGroup.rotation.y = groupRotY;
        // UV-mesh mode: artwork is applied directly to the GLB mesh materials —
        // backface culling (THREE.FrontSide) handles visibility automatically.
        // Legacy overlay planes: fade based on camera-face exposure angle.
        if (!uvModeActive) {
          var frontExposure = t3Cam.position.z * Math.cos(groupRotY) + t3Cam.position.x * Math.sin(groupRotY);
          var camDistXZ = Math.sqrt(t3Cam.position.x * t3Cam.position.x + t3Cam.position.z * t3Cam.position.z);
          var normExp = camDistXZ > 0 ? frontExposure / camDistXZ : 0;
          var frontVis = normExp > 0 ? normExp * normExp : 0;
          var backVis  = normExp < 0 ? normExp * normExp : 0;
          if (planeFront && planeFront.material.map)  planeFront.material.opacity  = frontVis;
          if (planeBack  && planeBack.material.map)   planeBack.material.opacity   = backVis;
        }
        // Smoothly tilt bag for bottom view
        groupRotX += (targetRotX - groupRotX) * 0.07;
        bagGroup.rotation.x = groupRotX;
        t3Cam.position.lerp(camPos, 0.07);
        t3Cam.lookAt(camLook);
        t3Renderer.render(t3Scene, t3Cam);
      }
      if (!t3AnimId) loop(); // guard against double-start
    }
    startLoop();

    var loader = new THREE.GLTFLoader();
    loader.load((window.VP_CDN+"mylar_bag.glb?v=88b956f6bc"),
      function(gltf) {
        // Guard against stale callbacks from a load that was superseded
        // (user switched away before the GLB finished downloading).
        if (thisGen !== mylarLoadGen) {
          var resources = new Set();
          gltf.scene.traverse(function(mesh) {
            if (mesh.geometry) resources.add(mesh.geometry);
            var materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
            materials.forEach(function(material) {
              if (!material) return;
              resources.add(material);
              Object.keys(material).forEach(function(key) {
                if (material[key] && material[key].isTexture) resources.add(material[key]);
              });
            });
          });
          resources.forEach(function(resource) { resource.dispose(); });
          return;
        }
        var model = gltf.scene;
        // Auto-centre and scale
        var box = new THREE.Box3().setFromObject(model);
        var cen = box.getCenter(new THREE.Vector3());
        var siz = box.getSize(new THREE.Vector3());
        var sf  = 2.8 / Math.max(siz.x, siz.y, siz.z);
        model.scale.setScalar(sf);
        model.position.copy(cen.multiplyScalar(-sf));

        // ── Step 1: Apply base metallic-silver material to every mesh ────────
        model.traverse(function(ch) {
          if (!ch.isMesh) return;
          ch.material = new THREE.MeshPhysicalMaterial({
            color:              0xc8d4dc,  // cool silver — typical mylar bag tone
            metalness:          0.95,      // nearly full metal
            roughness:          0.04,      // very smooth surface = tight, bright reflections
            clearcoat:          1.0,       // glossy lacquer coat over the metal
            clearcoatRoughness: 0.06,      // almost mirror clearcoat
            side: THREE.DoubleSide         // DoubleSide: bag exterior visible from all camera angles
          });
        });

        bagGroup.add(model);
        model.updateMatrixWorld(true);
        var mb = new THREE.Box3().setFromObject(model);

        // ── Step 2: Scan vertex positions + UV coordinates to find the UV region
        // that corresponds to each bag face.
        //
        // The centroid approach fails for this GLB because each mesh spans the full
        // bag (front+back+gussets in one object, centroid ≈ origin for all).  Instead
        // we inspect every vertex: vertices whose world-Z is near the front face have
        // specific UV coordinates → those UVs define the "front face UV region".
        // We then paint artwork directly into that region of a shared texture.
        var bx = mb.max.x - mb.min.x;
        var bh = mb.max.y - mb.min.y;
        var bd = mb.max.z - mb.min.z;
        var midZ = (mb.max.z + mb.min.z) / 2;
        var midY = (mb.max.y + mb.min.y) / 2;
        // Z threshold: vertices within 25% of the depth from each face extreme
        var zFaceThresh = bd * 0.25;
        // Y threshold: bottom gusset vertices are in the lowest 25% of bag height
        var yGussetThresh = mb.min.y + bh * 0.25;

        // UV bounding rect for each face.  Initialised inverted so any real value shrinks/grows it.
        var uvFace = {
          front:  { u0: 1, u1: 0, v0: 1, v1: 0 },
          back:   { u0: 1, u1: 0, v0: 1, v1: 0 },
          bottom: { u0: 1, u1: 0, v0: 1, v1: 0 }
        };

        // Local-space position bounds per face — used by the position-based UV shader.
        // These record the raw `position` attribute values (model local space),
        // which is exactly what GLSL `position` gives in the vertex shader.
        var posFace = {
          front:  { x0: Infinity, x1: -Infinity, y0: Infinity, y1: -Infinity, z0: Infinity, z1: -Infinity },
          back:   { x0: Infinity, x1: -Infinity, y0: Infinity, y1: -Infinity, z0: Infinity, z1: -Infinity },
          bottom: { x0: Infinity, x1: -Infinity, z0: Infinity, z1: -Infinity }
        };

        // Printable-zone world-space bounds — vertices outside these are structural
        // (zipper, side-folds, gusset transition) and should NOT influence the artwork
        // position bounds, or the artwork gets stretched into those non-print areas.
        //   Top  15% of bag height → zipper / seal hardware
        //   Bottom 10%            → gusset fold transition (already caught by yGussetThresh)
        //   Outer 5% of half-width → side edge folds
        var _pzYMin  = mb.min.y;                                 // full face bottom (no trim)
        var _pzYMax  = mb.max.y;                                 // full face top including zipper
        var _pzMidX  = (mb.max.x + mb.min.x) / 2;              // bag centre X (kept for reference)
        var _pzXHalf = Infinity;                                 // no X limit — face edge vertices set true width

        var _sv = new THREE.Vector3();
        var _lv = new THREE.Vector3();
        model.traverse(function(ch) {
          if (!ch.isMesh || !ch.geometry) return;
          var posAttr = ch.geometry.attributes.position;
          var uvAttr  = ch.geometry.attributes.uv;
          var normAttr = ch.geometry.attributes.normal;
          if (!posAttr) return;
          for (var i = 0; i < posAttr.count; i++) {
            _sv.fromBufferAttribute(posAttr, i).applyMatrix4(ch.matrixWorld); // world pos → face classification
            _lv.fromBufferAttribute(posAttr, i);                              // local pos → UV bounds
            var u = uvAttr ? uvAttr.getX(i) : 0;
            var v = uvAttr ? uvAttr.getY(i) : 0;
            var face = null;
            if (_sv.z > midZ + zFaceThresh)       face = 'front';
            else if (_sv.z < midZ - zFaceThresh)  face = 'back';
            else if (_sv.y < yGussetThresh)        face = 'bottom';
            if (!face) continue;
            if (uvAttr) {
              var r = uvFace[face];
              if (u < r.u0) r.u0 = u;  if (u > r.u1) r.u1 = u;
              if (v < r.v0) r.v0 = v;  if (v > r.v1) r.v1 = v;
            }
            // Track local-space X/Y bounds for all face vertices — includes zipper area
            // so the artwork UV range covers the full height (bottom to top of bag).
            var pf = posFace[face];
            if (_lv.x < pf.x0) pf.x0 = _lv.x;
            if (_lv.x > pf.x1) pf.x1 = _lv.x;
            if (face === 'bottom') {
              if (_lv.z < pf.z0) pf.z0 = _lv.z;
              if (_lv.z > pf.z1) pf.z1 = _lv.z;
            } else {
              if (_lv.y < pf.y0) pf.y0 = _lv.y;
              if (_lv.y > pf.y1) pf.y1 = _lv.y;
            }
            // For Z-center computation: only count CLEARLY front/back-facing normals.
            // This avoids corner/gusset-edge vertices (world-Z classified as 'front' but
            // with local Z extending toward center) from corrupting the centerZ threshold.
            if (face !== 'bottom' && normAttr) {
              var _nzc = normAttr.getZ(i);
              if (face === 'front' && _nzc < -0.15) {
                if (_lv.z < pf.z0) pf.z0 = _lv.z;
                if (_lv.z > pf.z1) pf.z1 = _lv.z;
              }
              if (face === 'back' && _nzc > 0.15) {
                if (_lv.z < pf.z0) pf.z0 = _lv.z;
                if (_lv.z > pf.z1) pf.z1 = _lv.z;
              }
            }
          }
        });

        console.log('[MylarBag UV Scan] front UV:',
          uvFace.front.u0.toFixed(3), uvFace.front.u1.toFixed(3),
          uvFace.front.v0.toFixed(3), uvFace.front.v1.toFixed(3));
        console.log('[MylarBag UV Scan] back UV:',
          uvFace.back.u0.toFixed(3),  uvFace.back.u1.toFixed(3),
          uvFace.back.v0.toFixed(3),  uvFace.back.v1.toFixed(3));
        console.log('[MylarBag UV Scan] bottom UV:',
          uvFace.bottom.u0.toFixed(3), uvFace.bottom.u1.toFixed(3),
          uvFace.bottom.v0.toFixed(3), uvFace.bottom.v1.toFixed(3));

        // A face UV rect is valid if it has non-zero area
        function uvValid(r) { return r.u1 > r.u0 + 0.01 && r.v1 > r.v0 + 0.01; }

        // Check if front and back UV rects overlap — if they do we cannot paint them
        // independently on a shared texture (mirrored UVs), must fall back to planes.
        function uvOverlap(a, b) {
          return a.u0 < b.u1 && a.u1 > b.u0 && a.v0 < b.v1 && a.v1 > b.v0;
        }
        var frontBackOverlap = uvValid(uvFace.front) && uvValid(uvFace.back) &&
                               uvOverlap(uvFace.front, uvFace.back);
        console.log('[MylarBag UV Scan] front/back overlap:', frontBackOverlap);

        // ── Build combined artwork canvas texture ─────────────────────────────
        // ── Shader-injection approach ────────────────────────────────────────
        // The GLB uses mirrored UVs: front and back panels share the same UV region
        // (overlap: true above).  A shared canvas-texture cannot distinguish them.
        //
        // Solution: inject GLSL into Three.js's PBR shader that uses each vertex's
        // LOCAL-SPACE Z POSITION to decide which face it belongs to:
        //   vLocalPos.z >= u_frontZThresh → front face → sample u_frontTex
        //   vLocalPos.z <= u_backZThresh  → back  face → sample u_backTex
        //   vLocalNorm.y < -0.5           → bottom gusset → sample u_bottomTex
        // Z-position classification covers the FULL face including the zipper area,
        // where normals curve sideways and would fail a normal-direction test.
        //
        // The mesh's UV coordinates only cover a small region (e.g. U 0.25–0.52).
        // We pass the face's UV bounds as a uniform and remap to full 0→1 before
        // sampling, so the artwork fills the entire face without stretching.

        // 1×1 transparent canvas — the "no artwork yet" placeholder texture.
        function _mkBlankTex() {
          var c = document.createElement('canvas');
          c.width = c.height = 1; // transparent by default
          var t = new THREE.CanvasTexture(c);
          t.flipY = false;
          return t;
        }

        // Shared uniform objects — updating .value propagates to every mesh instantly.
        // Position-based bounds: the shader uses local-space vertex positions (not UV atlas)
        // to map artwork onto the bag, which avoids the mirrored-UV problem entirely.
        //   u_frontPosB / u_backPosB : vec4(xMin, xMax, yMin, yMax)  — front/back panels
        //   u_bottomPosB             : vec4(xMin, xMax, zMin, zMax)  — bottom gusset
        // Extract mesh scale from matrixWorld so we can convert local positions to
        // world-proportional coordinates in the shader.  The GLB may be modelled in
        // a normalised/square local space then scaled non-uniformly to make the bag
        // portrait — using raw local coords gives a square artwork mapping.
        // Scale is rotation-invariant, so this correction stays correct as the bag spins.
        var _mSc = new THREE.Vector3(1, 1, 1);
        var _yMaxAll = posFace.front.y1;  // start at existing front y1, expand to full model
        model.traverse(function(ch) {
          if (!ch.isMesh) return;
          var _st = new THREE.Vector3(), _sq = new THREE.Quaternion();
          ch.matrixWorld.decompose(_st, _sq, _mSc);
          // Track max local Y across ALL vertices so artwork extends into zipper hardware.
          // The face-classification scan only counted world-Z-classified front/back vertices,
          // which typically excludes the zipper at the top (intermediate world Z).
          if (ch.geometry) {
            var _pa2 = ch.geometry.attributes.position;
            if (_pa2) {
              for (var _vi2 = 0; _vi2 < _pa2.count; _vi2++) {
                var _vy2 = _pa2.getY(_vi2);
                if (_vy2 > _yMaxAll) _yMaxAll = _vy2;
              }
            }
          }
        });
        // Extend front/back Y bounds to full model height so artwork covers zipper area.
        // Any front-classified zipper vertex (caught by hybrid classifier) will map its UV
        // into the top portion of the artwork canvas instead of being clamped to the top edge.
        posFace.front.y1 = _yMaxAll;
        posFace.back.y1  = _yMaxAll;
        // Compute center-Z for the hybrid face classifier.
        //
        // The Z bounds in posFace are populated only from CLEARLY front/back-facing normals
        // (nz < -0.15 for front, nz > 0.15 for back), so they represent the flat panels only —
        // not corner/gusset-edge vertices.
        //
        //   front.z1 = innermost local Z of clearly-front vertices  (e.g. -0.15)
        //   back.z0  = innermost local Z of clearly-back vertices   (e.g. +0.15)
        //   centerZ  = midpoint between them                        (e.g.  0.00)
        //
        // The shader uses a HYBRID strategy:
        //   |nz| > 0.1  → use normal direction (works perfectly for the main bag body)
        //   |nz| ≤ 0.1  → use Z < centerZ for front, Z ≥ centerZ for back
        //                  (handles zipper/edge area where normals curve sideways)
        var _centerZ = (posFace.front.z1 + posFace.back.z0) / 2;

        console.log('[MylarBag Scale] mesh worldScale:', _mSc.x.toFixed(4), _mSc.y.toFixed(4), _mSc.z.toFixed(4));
        console.log('[MylarBag PosB] front x:', posFace.front.x0.toFixed(3), posFace.front.x1.toFixed(3),
          'y:', posFace.front.y0.toFixed(3), posFace.front.y1.toFixed(3), '(extended to full model height)',
          'cleanZ:', posFace.front.z0.toFixed(3), '→', posFace.front.z1.toFixed(3));
        console.log('[MylarBag PosB] back x:', posFace.back.x0.toFixed(3), posFace.back.x1.toFixed(3),
          'y:', posFace.back.y0.toFixed(3), posFace.back.y1.toFixed(3),
          'cleanZ:', posFace.back.z0.toFixed(3), '→', posFace.back.z1.toFixed(3));
        console.log('[MylarBag CenterZ]', _centerZ.toFixed(4),
          '  (front.z1=', posFace.front.z1.toFixed(4), ', back.z0=', posFace.back.z0.toFixed(4), ')');
        console.log('[MylarBag PosB scaled] front x:', (posFace.front.x0*_mSc.x).toFixed(4), (posFace.front.x1*_mSc.x).toFixed(4),
          'y:', (posFace.front.y0*_mSc.y).toFixed(4), (posFace.front.y1*_mSc.y).toFixed(4));

        var artShaderUniforms = {
          u_frontTex:     { value: _mkBlankTex() },
          u_backTex:      { value: _mkBlankTex() },
          u_bottomTex:    { value: _mkBlankTex() },
          // Bounds stored in SCALED local space (local * meshScale ≈ world-at-rest positions)
          // so the artwork aspect ratio matches the bag's visual proportions.
          //
          // NOTE on negative scaleX (-0.9954): the bounds are stored raw (not sorted by
          // Math.min/max) so that x0*scaleX > x1*scaleX (swapped after negative multiply).
          // The U coordinate in the shader naturally comes out MIRRORED from these swapped
          // bounds, which is then corrected by the explicit `1.0 - _r.x` flip on each face
          // in the map_fragment injection below. Both front and back use the flip.
          u_meshScale:    { value: new THREE.Vector2(_mSc.x, _mSc.y) },
          u_frontPosB:    { value: new THREE.Vector4(
            posFace.front.x0  * _mSc.x, posFace.front.x1  * _mSc.x,
            posFace.front.y0  * _mSc.y, posFace.front.y1  * _mSc.y) },
          u_backPosB:     { value: new THREE.Vector4(
            posFace.back.x0   * _mSc.x, posFace.back.x1   * _mSc.x,
            posFace.back.y0   * _mSc.y, posFace.back.y1   * _mSc.y) },
          u_bottomPosB:   { value: new THREE.Vector4(
            posFace.bottom.x0 * _mSc.x, posFace.bottom.x1 * _mSc.x,
            posFace.bottom.z0 * _mSc.z, posFace.bottom.z1 * _mSc.z) },
          // Hybrid classifier: main body uses normals (clear), zipper zone uses Z position.
          // u_centerZ is the midpoint between the clean inner Z surfaces of front and back panels.
          u_centerZ:  { value: _centerZ },
          // Image aspect ratios — set when artwork is uploaded; used for AR-correct UV sampling.
          u_frontAR:  { value: 1.0 },
          u_backAR:   { value: 1.0 },
          u_bottomAR: { value: 1.0 }
        };
        // UV direction (confirmed by debug gradient test):
        // _r.x=0 is at viewer LEFT for front face → front uses _r.x (no flip).
        // _r.x=0 is at viewer RIGHT for back face  → back uses 1.0-_r.x.
        bagGroup.userData.artShaderUniforms = artShaderUniforms;

        model.traverse(function(ch) {
          if (!ch.isMesh) return;
          var mat = new THREE.MeshPhysicalMaterial({
            color:              0xc8d4dc,  // silver base — shown where no artwork is present
            metalness:          0.15,      // reduced so printed artwork isn't washed out
            roughness:          0.55,      // more diffuse = less specular glare on artwork
            clearcoat:          0.10,      // minimal clearcoat — main source of bright hotspots
            clearcoatRoughness: 0.65,
            side:               THREE.DoubleSide
          });
          // Force USE_UV so vUv varying is declared by Three.js (needed for texture sampling).
          // Without a map/normalMap/etc set, Three.js would omit USE_UV and vUv would be undefined.
          mat.defines['USE_UV'] = '';

          mat.onBeforeCompile = function(shader) {
            // ── Wire shared uniforms ──────────────────────────────────────────
            shader.uniforms.u_frontTex   = artShaderUniforms.u_frontTex;
            shader.uniforms.u_backTex    = artShaderUniforms.u_backTex;
            shader.uniforms.u_bottomTex  = artShaderUniforms.u_bottomTex;
            shader.uniforms.u_meshScale  = artShaderUniforms.u_meshScale;
            shader.uniforms.u_frontPosB  = artShaderUniforms.u_frontPosB;
            shader.uniforms.u_backPosB   = artShaderUniforms.u_backPosB;
            shader.uniforms.u_bottomPosB = artShaderUniforms.u_bottomPosB;
            shader.uniforms.u_centerZ    = artShaderUniforms.u_centerZ;
            shader.uniforms.u_frontAR    = artShaderUniforms.u_frontAR;
            shader.uniforms.u_backAR     = artShaderUniforms.u_backAR;
            shader.uniforms.u_bottomAR   = artShaderUniforms.u_bottomAR;

            // ── Vertex shader ─────────────────────────────────────────────────
            // Pass local-space normal (face ID) and local-space position (artwork UVs).
            // Using `position` (raw attribute) bypasses the UV atlas entirely — no
            // mirrored-UV problems, no UV island rotation to correct.
            shader.vertexShader = shader.vertexShader.replace(
              '#include <uv_pars_vertex>',
              '#include <uv_pars_vertex>\nvarying vec3 vLocalNorm;\nvarying vec3 vLocalPos;'
            );
            shader.vertexShader = shader.vertexShader.replace(
              '#include <begin_vertex>',
              '#include <begin_vertex>\nvLocalNorm = normalize( normal );\nvLocalPos = position;'
            );

            // ── Fragment shader ───────────────────────────────────────────────
            // HYBRID face classifier — primary: normal direction; fallback: local Z.
            //
            // PRIMARY (main bag body where normals are clear):
            //   vLocalNorm.z < -0.1  →  front face
            //   vLocalNorm.z >  0.1  →  back  face
            //
            // FALLBACK (zipper/curved top where abs(nz) ≤ 0.1, normals curve sideways):
            //   vLocalPos.z < u_centerZ   →  front (front panel is at lower local Z)
            //   vLocalPos.z >= u_centerZ  →  back
            //   u_centerZ = midpoint of clean front/back inner surfaces (gusset midpoint)
            //
            // BOTTOM gusset: vLocalNorm.y < -0.5 (downward normals)
            //
            // Artwork UV: scaled local X/Y so aspect ratio matches the bag's visual proportions.
            // u_*PosB uniforms: vec4(xMin, xMax, yMin_or_zMin, yMax_or_zMax)
            shader.fragmentShader = shader.fragmentShader.replace(
              '#include <uv_pars_fragment>',
              '#include <uv_pars_fragment>\n' +
              'uniform sampler2D u_frontTex;\n' +
              'uniform sampler2D u_backTex;\n' +
              'uniform sampler2D u_bottomTex;\n' +
              'uniform vec2  u_meshScale;\n' +
              'uniform vec4  u_frontPosB;\n' +
              'uniform vec4  u_backPosB;\n' +
              'uniform vec4  u_bottomPosB;\n' +
              'uniform float u_centerZ;\n' +
              'uniform float u_frontAR;\n' +
              'uniform float u_backAR;\n' +
              'uniform float u_bottomAR;\n' +
              'varying vec3  vLocalNorm;\n' +
              'varying vec3  vLocalPos;\n' +
              'vec4 _artFlat = vec4(0.0);\n'
            );

            // Helper macro (inlined as a string fragment): AR-correct contain-mode UV.
            // Given raw face UVs (ru, rv in [0,1]) and the image AR, returns corrected
            // (rx, ry) such that a circle in the image appears circular on the face.
            // If the sample falls outside [0,1] it returns alpha=0 (bag material shows).
            var _arUV =
              'float _arCorrect(float ru, float imgAR, float faceW, float faceH) {\n' +
              '  return ru;\n' + // placeholder — actual logic inlined per axis below
              '}\n';

            shader.fragmentShader = shader.fragmentShader.replace(
              '#include <map_fragment>',
              '#include <map_fragment>\n' +
              '{\n' +
              '  vec4 _art = vec4(0.0);\n' +
              '  vec3 _sp = vec3(vLocalPos.x * u_meshScale.x, vLocalPos.y * u_meshScale.y, vLocalPos.z);\n' +
              '  float _nz = vLocalNorm.z;\n' +
              '  float _midY = (u_frontPosB.z + u_frontPosB.w) * 0.5;\n' +
              // ── Bottom gusset ───────────────────────────────────────────────────────
              '  if (vLocalNorm.y < -0.5 && _sp.y < _midY) {\n' +
              '    vec2 _r = clamp(vec2(\n' +
              '      (_sp.x - u_bottomPosB.x) / (u_bottomPosB.y - u_bottomPosB.x),\n' +
              '      (vLocalPos.z * u_meshScale.x - u_bottomPosB.z) / (u_bottomPosB.w - u_bottomPosB.z)\n' +
              '    ), 0.0, 1.0);\n' +
              '    _art = texture2D(u_bottomTex, vec2(_r.x, 1.0 - _r.y));\n' +
              // ── Front face — COVER-mode AR correction ───────────────────────────────
              // Cover mode: scale the shorter image dimension so it fills the face.
              // One dimension always covers exactly; the other may be cropped at the edges.
              // Mathematically ensures a circle in the image appears circular on the face.
              '  } else if ((_nz < -0.1) || (abs(_nz) <= 0.1 && vLocalPos.z < u_centerZ)) {\n' +
              // UV mapping: derive printable face height from image AR × face width.
              // The artwork was designed for this bag, so imgAR gives the correct face proportion.
              // Artwork is CENTERED on the face so it sits in the middle of the bag, not bottom-anchored.
              // Areas above/below the artwork map outside [0,1] and clamp to the artwork edge color.
              '    float _ru = (_sp.x - u_frontPosB.x) / (u_frontPosB.y - u_frontPosB.x);\n' +
              '    float _fW = abs(u_frontPosB.y - u_frontPosB.x);\n' +
              '    float _natH = (u_frontAR > 0.001) ? _fW / u_frontAR : _fW;\n' +
              '    float _faceCenterY = (u_frontPosB.z + u_frontPosB.w) * 0.5;\n' +
              '    float _rv = (_natH > 0.001) ? (_sp.y - _faceCenterY) / _natH + 0.5 : 0.5;\n' +
              '    _art = texture2D(u_frontTex, vec2(clamp(_ru,0.0,1.0), 1.0 - clamp(_rv,0.0,1.0)));\n' +
              // ── Back face — same centered image-AR-derived mapping, U flipped ──
              '  } else if ((_nz > 0.1) || (abs(_nz) <= 0.1 && vLocalPos.z >= u_centerZ)) {\n' +
              '    float _ru = 1.0 - ((_sp.x - u_backPosB.x) / (u_backPosB.y - u_backPosB.x));\n' +
              '    float _fW = abs(u_backPosB.y - u_backPosB.x);\n' +
              '    float _natH = (u_backAR > 0.001) ? _fW / u_backAR : _fW;\n' +
              '    float _faceCenterY = (u_backPosB.z + u_backPosB.w) * 0.5;\n' +
              '    float _rv = (_natH > 0.001) ? (_sp.y - _faceCenterY) / _natH + 0.5 : 0.5;\n' +
              '    _art = texture2D(u_backTex, vec2(clamp(_ru,0.0,1.0), 1.0 - clamp(_rv,0.0,1.0)));\n' +
              '  }\n' +
              '  if (_art.a > 0.01) { _artFlat = _art; diffuseColor.rgb = vec3(0.0); }\n' +
              '}\n'
            );

            // After tone mapping: blend raw artwork color with PBR specular, gated by surface flatness.
            //
            // diffuseColor.rgb was zeroed in map_fragment, so gl_FragColor here is SPECULAR-ONLY
            // (clearcoat + direct specular + IBL reflections — no diffuse contribution).
            //
            // The blend factor is driven by abs(vLocalNorm.z):
            //   abs(nz) ≈ 1.0  → normal points straight at camera → FLAT face → pure artwork color
            //   abs(nz) ≈ 0.0  → normal points sideways → curved edge / zipper ridge → full specular
            //
            // This means:
            //   · Flat printable face  → specFactor ≈ 0 → artwork matches upload exactly  ✓
            //   · Bag side edges       → specFactor ≈ 1 → edge shading / 3D depth         ✓
            //   · Zipper ridge seams   → specFactor ≈ 0.5–0.8 → bright zipper lines       ✓
            //   · Gusset (no artwork)  → _artFlat.a = 0, override skipped → full PBR sheen ✓
            shader.fragmentShader = shader.fragmentShader.replace(
              '#include <tonemapping_fragment>',
              '#include <tonemapping_fragment>\n' +
              'if (_artFlat.a > 0.01) {\n' +
              '  float _flatness = abs(vLocalNorm.z);\n' +
              '  float _specFactor = pow(max(1.0 - _flatness, 0.0), 1.5);\n' +
              '  gl_FragColor = vec4(_artFlat.rgb + gl_FragColor.rgb * _specFactor, gl_FragColor.a);\n' +
              '}\n'
            );
          };
          // All bag meshes share the same compiled shader program (uniforms are shared too)
          mat.customProgramCacheKey = function() { return 'bagArtworkShader'; };
          ch.material = mat;
        });
        uvModeActive = true;
        console.log('[MylarBag] Position-based shader active. Front pos bounds logged above.');
        // ── Test hook (read-only, production-safe) ──────────────────────────
        // Exposes live shader uniform values for automated Playwright tests.
        // No performance impact — the hook object is only read when tests call it.
        if (!window.__vpTestHooks) window.__vpTestHooks = {};
        window.__vpTestHooks.getShaderUniforms = function() {
          return {
            shaderActive: uvModeActive,
            frontAR:  artShaderUniforms.u_frontAR.value,
            backAR:   artShaderUniforms.u_backAR.value,
            bottomAR: artShaderUniforms.u_bottomAR.value
          };
        };

        // ── Step 3: Overlay planes — only built when UV mode is NOT active ────
        // (Kept as fallback in case the GLB lacks per-face UV coordinates.)
        var fz = mb.max.z;
        var bz = mb.min.z;
        if (!uvModeActive) {
          var pw      = bx * 0.96;
          var ph      = bh * 0.84;
          var cy      = mb.min.y + bh * 0.50;
          var printLo = cy - ph / 2;
          var faceThresh = bd * 0.18;
          planePrintW = pw;
          planePrintH = ph;

          var BANDS    = 20;
          var bandStep = ph / BANDS;
          var bFrontZ  = [], bBackZ = [];
          for (var _bi = 0; _bi <= BANDS; _bi++) {
            bFrontZ.push(-Infinity); bBackZ.push(Infinity);
          }
          var _pv = new THREE.Vector3();
          model.traverse(function(ch) {
            if (!ch.isMesh || !ch.geometry) return;
            var pa = ch.geometry.attributes.position;
            if (!pa) return;
            for (var vi = 0; vi < pa.count; vi++) {
              _pv.fromBufferAttribute(pa, vi).applyMatrix4(ch.matrixWorld);
              if (_pv.y < printLo || _pv.y > printLo + ph) continue;
              var bi = Math.min(BANDS, Math.floor((_pv.y - printLo) / bandStep));
              if (Math.abs(_pv.x) <= bx * 0.40) {
                if (_pv.z > fz - faceThresh && _pv.z > bFrontZ[bi]) bFrontZ[bi] = _pv.z;
                if (_pv.z < bz + faceThresh && _pv.z < bBackZ[bi])  bBackZ[bi]  = _pv.z;
              }
            }
          });
          var constHW = [];
          for (var _bi2 = 0; _bi2 <= BANDS; _bi2++) {
            if (bFrontZ[_bi2] === -Infinity) bFrontZ[_bi2] = fz;
            if (bBackZ[_bi2]  ===  Infinity) bBackZ[_bi2]  = bz;
            constHW.push(pw / 2);
          }
          planeFront = makeConformingPlane(bFrontZ, constHW, printLo, bandStep, BANDS, 0);
          var bBackZFlipped = [];
          for (var _ci2 = 0; _ci2 <= BANDS; _ci2++) bBackZFlipped.push(-bBackZ[_ci2]);
          planeBack = makeConformingPlane(bBackZFlipped, constHW, printLo, bandStep, BANDS, Math.PI);
          var gussetW = bx * 1.00;
          var botH    = bd * 1.00;
          planeBottom = makePlane(gussetW, gussetW, botH, 0, mb.min.y,
                                  (mb.max.z + mb.min.z) / 2, Math.PI / 2, 0);
          planePrintW_bot = gussetW;
          planePrintH_bot = botH;
        }

        // NOW expose applyArtwork — UV meshes (or fallback planes) are ready
        t3ApplyArtwork = function(url, view) { applyArtwork(url, view); };

        // Apply whichever artworks have already been uploaded
        if (artworkDataUrl)            applyArtwork(artworkDataUrl,            'front');
        if (mylarBackArtworkDataUrl)   applyArtwork(mylarBackArtworkDataUrl,   'back');
        if (mylarBottomArtworkDataUrl) applyArtwork(mylarBottomArtworkDataUrl, 'bottom');

        // GLB is ready — start rotating and fade out the static placeholder image.
        // (wrap is already visible — shown immediately when the renderer was created)
        autoRotate = true;
        var _pImg = document.getElementById('productImg');
        if (_pImg) { _pImg.style.opacity = '0'; _pImg.style.visibility = 'hidden'; }
        // (loop already running — no startLoop call needed here)
      },
      undefined,
      function(err) {
        if (thisGen !== mylarLoadGen) return;
        console.warn('GLB load failed, using fallback box:', err);
        var fallbackGeo = new THREE.BoxGeometry(1.5, 2.2, 0.35);
        var fallbackMat = new THREE.MeshPhysicalMaterial({ color: 0xc8d4dc, metalness: 0.95, roughness: 0.04, clearcoat: 1.0, clearcoatRoughness: 0.06 });
        var fallbackMesh = new THREE.Mesh(fallbackGeo, fallbackMat);
        bagGroup.add(fallbackMesh);
        // Fallback planes — fixed positions for the box stand-in
        planeFront  = makePlane(1.2, 1.6, 0,  0.1,  0.19, 0,           0);
        planeBack   = makePlane(1.2, 1.6, 0,  0.1, -0.19, 0,    Math.PI);
        planeBottom = makePlane(1.2, 0.4, 0, -1.12, 0,    Math.PI/2,   0);
        t3ApplyArtwork = function(url, view) { applyArtwork(url, view); };
        if (artworkDataUrl) applyArtwork(artworkDataUrl, 'front');
        // Canvas is already visible (wrap shown at renderer init) — just start rotation
        // and fade out the placeholder image.
        autoRotate = true;
        var _pImg = document.getElementById('productImg');
        if (_pImg) { _pImg.style.opacity = '0'; _pImg.style.visibility = 'hidden'; }
        // (loop already running)
      }
    );

    // ── Drag rotation (mouse + touch) ──────────────────────────────────────
    t3Renderer.domElement.addEventListener('mousedown', function(e) {
      isDragging = true; autoRotate = false; prevX = e.clientX;
    });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      groupRotY += (e.clientX - prevX) * 0.012; prevX = e.clientX;
      targetRotY = groupRotY; // keep target in sync so lerp doesn't snap back after release
    });
    window.addEventListener('mouseup', function() { isDragging = false; });
    t3Renderer.domElement.addEventListener('touchstart', function(e) {
      autoRotate = false; prevX = e.touches[0].clientX;
    }, { passive: true });
    t3Renderer.domElement.addEventListener('touchmove', function(e) {
      groupRotY += (e.touches[0].clientX - prevX) * 0.012;
      targetRotY = groupRotY; // keep target in sync
      prevX = e.touches[0].clientX; e.preventDefault();
    }, { passive: false });

    // ── View buttons ───────────────────────────────────────────────────────
    var vt = document.getElementById('viewToggle');
    if (vt) {
      vt.innerHTML =
        '<button class="view-btn active" id="btnFrontView"  data-qa="mylar-btn-front"  onclick="preview3D.setCameraView(\'front\')">▶ Front</button>' +
        '<button class="view-btn"        id="btnBackView"   data-qa="mylar-btn-back"   onclick="preview3D.setCameraView(\'back\')">◀ Back</button>' +
        '<button class="view-btn"        id="btnBottomView" data-qa="mylar-btn-bottom" onclick="preview3D.setCameraView(\'bottom\')">↓ Bottom</button>';
      vt.classList.add('visible');  // make view toggle visible (mylar path)
    }

    function setActiveBtn(view) {
      ['front','back','bottom'].forEach(function(v) {
        var btn = document.getElementById('btn' + v.charAt(0).toUpperCase() + v.slice(1) + 'View');
        if (btn) btn.classList.toggle('active', v === view);
      });
    }

    t3SetCameraView = function(view) {
      mylarCurrentView = view;
      setActiveBtn(view);
      autoRotate = false;
      targetRotY = 0;   // snap bag back to face-on — camera move alone is insufficient if bag was rotated
      setCamTarget(view);
      // Sync upload tab
      var tab = 'mylar-' + view;
      if (currentCat === 'packaging' && currentUploadTab !== tab) setUploadTab(tab);
      // Apply correct artwork for this face
      var url = view === 'back'   ? mylarBackArtworkDataUrl :
                view === 'bottom' ? mylarBottomArtworkDataUrl : artworkDataUrl;
      if (url) applyArtwork(url, view);
    };

    t3Cleanup = function() {
      [planeFront, planeBack, planeBottom].forEach(function(p) {
        if (!p) return;
        if (p.material.map) p.material.map.dispose();
        p.geometry.dispose(); p.material.dispose();
      });
      planeFront = planeBack = planeBottom = null;
    };
  }

  // ── Public: deactivate ─────────────────────────────────────────────────
  function deactivate() {
    mylarLoadGen += 1;
    if (t3AnimId)   { cancelAnimationFrame(t3AnimId); t3AnimId = null; }
    if (t3Renderer) { t3Renderer.dispose(); t3Renderer = null; }
    if (t3Cleanup)  { t3Cleanup(); t3Cleanup = null; }
    t3Scene = t3Cam = t3Jar = null;
    t3SetCameraView = null;
    t3ApplyArtwork  = null;
    activeCanvas = null;
    var wrap = document.getElementById('preview3dWrap');
    if (wrap && !wrap.querySelector('#sticker-3d')) { wrap.innerHTML = ''; wrap.style.display = 'none'; }
    var productImgEl = document.getElementById('productImg');
    if (productImgEl) { productImgEl.style.visibility = ''; productImgEl.style.opacity = ''; }
    var vt = document.getElementById('viewToggle');
    if (vt) { vt.innerHTML = ''; vt.classList.remove('visible'); }
    showArtworkPreview();
  }

  // ── Public: refresh after new artwork upload ───────────────────────────
  function update() {
    if (t3SetCameraView) t3SetCameraView(mylarCurrentView || 'front');
  }

  return {
    activate:      activate,
    deactivate:    deactivate,
    update:        update,
    setCameraView: function(view) { if (t3SetCameraView) t3SetCameraView(view); },
    getCanvas:     function()     { return activeCanvas; }
  };
})();
